import styled, { css } from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

const fontStyles = css`
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 2px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${o => o.theme.spacing(5)};
`

export const ActionsBar = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

export const EmbroideryLabel = styled.div`
  display: flex;
  gap: ${o => o.theme.spacing(2)};
`

export const RightContent = styled.div`
  ${fontStyles}
  align-items: center;
  display: flex;
  justify-content: center;
`

export const EditButton = styled.button`
  ${TypeStyle.css.headlineMicro};
  color: ${o => o.theme.color.text.secondary.on.background};
  text-decoration: underline;

  &:hover {
    color: ${o => o.theme.color.text.primary.on.background};
  }
`
